module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "view-login-container"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "container is-fluid",
    attrs: {
      "id": "view-login"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login-form-container"
    }
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('p', {
    staticClass: "control",
    attrs: {
      "id": "login-btn-container"
    }
  }, [_c('button', {
    staticClass: "btn-submit-login button is-success",
    class: [_vm.btnIsLoading ? 'is-loading' : ''],
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column",
    attrs: {
      "id": "logo-container"
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": require("../../assets/images/coches-big-black.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5649f732!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/index.vue
// module id = 322
// module chunks = 1